import React from "react";
import HistoriqClient from "./HistoriqClient";

function HistoriqueReservation() {
  return (
    <HistoriqClient />
  )
}

export default HistoriqueReservation